// Lightweight tracking helpers. All calls are no-ops if GTM/dataLayer isn't loaded.

export function pushEvent(event, params = {}) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
}

export function captureUtms() {
  if (typeof window === "undefined") return {};
  try {
    const p = new URLSearchParams(window.location.search);
    const out = {};
    for (const k of ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"]) {
      const v = p.get(k);
      if (v) out[k] = v;
    }
    // Persist for cross-page journeys within the same session
    if (Object.keys(out).length) {
      sessionStorage.setItem("hg_utms", JSON.stringify(out));
      return out;
    }
    const stored = sessionStorage.getItem("hg_utms");
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
}
